import { Injectable } from '@angular/core';


@Injectable()
export class NavMenuProvider {

  private activePage: string;
  private titleActivePage: string;
  
  constructor() { }

  getActivePage() {
    return this.activePage;
  }
  getTitleActivePage() {
    return this.titleActivePage;
  }

  setActivePage(page) {
    this.activePage = page;
    this.titleActivePage
  }
  setActivePageTitle(title) {
    this.titleActivePage = title;
  }

}



// WEBPACK FOOTER //
// ./src/providers/nav-menu/nav-menu.ts